export const FLAG_ENABLE_APP_MONITOR = 'ENABLE-APP-MONITOR';
export const FLAG_ENABLE_DATA_LAKE_MONITOR = 'ENABLE-DATA-LAKE-MONITOR';
export const FLAG_ENABLE_QUERY_STORE = 'ENABLE-QUERY-STORE';
//# sourceMappingURL=zoe-user-flags.js.map